import React, { useState, useEffect } from 'react';
import FormContainer from '../components/FormContainer';
import { CusFormLabel, HybridFormLabel, HybridFormLabelGrey, SingleFormLabel } from '../validation/Form-Components';
import service from '../services/StatusEnquiryApiService';
import Loading from '../components/Loading';
import helper from '../factory/Helper';
import { PDFExport, savePDF } from "@progress/kendo-react-pdf";
import config from '../appconfig/config.json';
import CusSavePrint from '../components/CusSavePrint';
import CusGreenBtn from '../components/CusGreenBtn';
import storage from '../factory/StorageFactory.js';
import mData from '../hybriddata/mainform.json';
import UploadStatus from '../hybridcomponents/UploadStatus.jsx';
import aipImgAAP from '../hybridImages/AIPStatusAAP.png';
import aipImgALP from '../hybridImages/AIPStatusALP.png';
import losData from '../hybriddata/loanstatusdata.json';
import AAPFreeholdProperty from '../hybridcomponents/AAPFreeholdProperty.jsx';
import AAPLeaseholdProperty from '../hybridcomponents/AAPLeaseholdProperty.jsx';
import AAPNoProperty from '../hybridcomponents/AAPNoProperty.jsx';
import nldata from '../hybriddata/nonlendingdata.json';

const AIPStatusApproved = (props) => {

    const financeTypeIslamic = 'islamic';
    const financeTypeConventional = 'conventional';

    const applicantStatusComplete = 'submitted';
    const applicantStatusPending = 'pending';

    const [refNo, setRefNo] = useState('');
    const [uen,setUEN] = useState('');

    const [isLoading, setIsLoading] = useState(true);  //to show api call
    const [response, setResponse] = useState();
    const pdfExportComponent = React.useRef(null);
    const container = React.useRef(null);

    const [buttonPopup, setButtonPopup] = useState(false);
 
    const [showNonLending,setShowNonLending] = useState(true);

    //CIPAIPResponse
    const [cipAipResponse,setCipAipResponse] = useState(null);

    //Property Details
    const [propertyDtl,setPropertyDtl]= useState();
    const [showWOProperty, setShowWOProperty] = useState(false);
    const [showFreeholdProp, setShowFreeholdProp] = useState(false);
    const [showLeaseholdProp, setShowLeaseholdProp] = useState(false);

    //upload document status

    const [isFirstDocSectDone, setIsFirstDocSectDone] = useState(false);
    const [isSecondDocSectDone, setIsSecondDocSectDone] = useState(false);
    const [isThirdDocSectDone,setIsThirdDocSectDone] = useState(false);

    useEffect(() => {
        console.log('@AIPStatusInfoDetails useEffect');
   
        window.scrollTo(0, 0);
        getStatusEnquiry();
        //clearData();
    }, []);

    const getStatusEnquiry = () => {

        const sid = storage.getStateId();
        const rno = storage.getRefNo();
        service.getStatusEnquiry(sid,rno).then( res => {
 
            let resData = res.data.model.fields.request;
            setResponse(resData);

            getCIPAIPResponse(resData); //For AIP Response
     
            setRefNo(resData.StatusDtls.ApplicationNo);
            setUEN(resData.StatusDtls.UEN);
      
            getUploadedDocStatus(rno);
        })
        .catch( err => {
            console.log('getStatus err: ',err);
            setIsLoading(false);
            props.history.push(config.route.InvalidEntity,{errType:config.ErrType.GetStatusFailed});
        })
    }

    const getCIPAIPResponse = (resData) => {
        if(resData.CIPAIPResponse !== null) {
            try{
                const jObj = JSON.parse(resData.CIPAIPResponse);
                // console.log('getCIPAIPResponse JSON: ',jObj)
                setCipAipResponse(jObj);
                checkLoanScenarios(jObj); // For AIP AAP scenarios
            }
            catch(e){
                console.log('Invalid CIPAIP RES',e);
            }
        }
        else {
            setCipAipResponse(null);
        }
    }

    const getUploadedDocStatus = (rno) => {

        service.getDocumentStatus(rno).then( res => {
            
            let resData = res.data.model;
       
            if(resData !== null) {
                setIsFirstDocSectDone((resData.hasFinancialStatement === 'Y'||resData.hasManagementAccount === 'Y'||resData.hasDraftAccount === 'Y')?true:false);
                setIsSecondDocSectDone((resData.hasBankStatement === 'Y')?true:false);
                setIsThirdDocSectDone((resData.hasOTP === 'Y')?true:false);
            }
   
            setIsLoading(false);
        })
        .catch( err => {
            console.log('getDocumentStatus err: ',err);
            setIsLoading(false);
            props.history.push(config.route.InvalidEntity,{errType:config.ErrType.GetStatusFailed});
        })
    }

    const getNonLendingString = () => {
        let result = '',temp = [];

        if(response.StatusDtls.MYCurrentAccount === 'N' && response.StatusDtls.FXDeskServices === 'N'
        && response.StatusDtls.BusinessInsurance === 'N' && response.StatusDtls.SMEStartDigital === 'N'
        && response.StatusDtls.HalalNetworkAndCertifiedAdvisory === 'N') {
            result = 'Not Applicable';
            return result;
        }

        if(response.StatusDtls.MYCurrentAccount === 'Y') {
            temp.push(nldata.product1.title);
        }
        if(response.StatusDtls.FXDeskServices === 'Y') {
            temp.push(nldata.product2.title);
        }
        if(response.StatusDtls.BusinessInsurance === 'Y'){
            temp.push(nldata.product3.title);
        }
        if(response.StatusDtls.SMEStartDigital === 'Y') {
            temp.push(nldata.product4.title);
        }
        if(response.StatusDtls.HalalNetworkAndCertifiedAdvisory === 'Y') {
            temp.push(nldata.product5.title);
        }
          
        
        if(temp.length === 1) {
            result = temp[0];
        }
        else {
            result = temp.join(', ');
        }

        return result;
    }
 

    const checkLoanScenarios = (res) => {
        if(!res.maxCIPAIPLoanAmtFreehold && !res.maxCIPAIPLoanAmtLeasehold &&
            !res.maxCIPAIPLoanAmtJTCLeasehold && !res.maxCIPAIPLoanAmtNonJTCLeasehold &&
            !res.maxCIPAIPLoanAmtLeasehold &&
            res.maxLoanDetailsNoProp
        ) {  //WO PROPERTY
            console.log('WO PROPERTY');
            setShowWOProperty(true);
            setShowFreeholdProp(false);
            setShowLeaseholdProp(false);
        }
        else if(res.maxCIPAIPLoanAmtFreehold &&
            !res.maxCIPAIPLoanAmtJTCLeasehold && !res.maxCIPAIPLoanAmtNonJTCLeasehold &&
            !res.maxCIPAIPLoanAmtLeasehold
        ) { //FREEHOLD
            console.log('FREEHOLD');
            setShowWOProperty(false);
            setShowFreeholdProp(true);
            setShowLeaseholdProp(false);
        }
        else if(res.maxCIPAIPLoanAmtJTCLeasehold || res.maxCIPAIPLoanAmtNonJTCLeasehold || 
            res.maxCIPAIPLoanAmtLeasehold
        ) { //LEASEHOLD
            console.log('LEASEHOLD');
            setShowWOProperty(false);
            setShowFreeholdProp(false);
            setShowLeaseholdProp(true); 
        }
        else {
            console.log('NO CASE!')
        }
    }

    //export and print pdf
    const exportPDFWithMethod = () => {
        let element = container.current || document.body;
        savePDF(element, {
            paperSize: 'auto',
            margin: 5,
            fileName: response.StatusDtls.ApplicationNo + '.pdf',
            proxyUrl: getProxyUrl()
        });
    };

    const printPDF = () => {
        window.print();
    }

    const getProxyUrl = () => {
        const url = helper.getPdfUrl('NSStatusDetails');
        return url;
    }
 

    const handleBacktoHome = (e) => {
        //route url to home screen
        window.location.href = config.link.BacktoHome;
     
    }

 
 
 
    if (isLoading) {
        return (
            <Loading />
        )
    }

    return (
        <PDFExport ref={pdfExportComponent} paperSize="auto" margin={10} fileName={refNo + '.pdf'}>
            <div className="container-fluid">
                <div className="outerdivsubheader">
                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <h2 className='completeTitle1 mb-0'>
                                {response.StatusDtls.ApplicationProgress === config.StatusDtls.AAP? losData.mainTitle.AAP:losData.mainTitle.ALP}
                            </h2>
                        </div>
                    </div>
                </div>
                
                <FormContainer>
                    <div className='statusImgHeader'>
                    {response.StatusDtls.ApplicationProgress === config.StatusDtls.AAP?
                        <img src={aipImgAAP} alt="aipAAPImg" /> 
                        :
                        <img src={aipImgALP} alt="aipAAPImg" /> 
                    }
                    </div>
                </FormContainer>

                <FormContainer>
                    <div style={{ textAlign: 'center', padding: '20px' }}>
                        <h2 className='status-header-txt status-marg'>
                            {response.StatusDtls.ApplicationProgress === config.StatusDtls.AAP?losData.yellowTitle.AAP:losData.yellowTitle.ALP}
                        </h2>
                    </div>
                    
                    <UploadStatus history={props.history} firstIconGreen={isFirstDocSectDone} secIconGreen={isSecondDocSectDone} thridIconGreen={isThirdDocSectDone} />
                    
                    <div style={{ width: '100%', marginLeft: '-10px', padding:'15px 0 10px 0'}}>
                        <hr className="hrgoldline" />
                    </div>

                    <div className='status-marg'>
                        <CusFormLabel leftLabelId={'lblAppNum'} leftLabelName={'Application Number'}
                            id={'appNum'} name={response.StatusDtls.ApplicationNo} />

                        <CusFormLabel leftLabelId={'lblAppNum'} leftLabelName={'UEN'}
                            id={'uen'} name={response.StatusDtls.UEN} />
                   
                        <CusFormLabel leftLabelId={'lblAppNum'} leftLabelName={'Facility'}
                            id={'facility'} name={response.StatusDtls.Facility} />

                        <CusFormLabel leftLabelId={'lblAppNum'} leftLabelName={'Financing Type'}
                            id={'financeType'} name={response.StatusDtls.FinancingType} />

                        <CusFormLabel leftLabelId={'lblPurpose'} leftLabelName={'Purpose'}
                            id={'purpose'} name={'Property'} />

                        <CusFormLabel leftLabelId={'lblCombinedApp'} leftLabelName={'Combined Applications (Non-lending)'}
                            id={'combinedApp'} name={getNonLendingString()} />
 
                        <CusFormLabel leftLabelId={'lblAppNum'} leftLabelName={'Submission Date'}
                            id={'date'} name={response.StatusDtls.AppDate} />
                     
                        <CusFormLabel leftLabelId={'lblAIPExpDate'} leftLabelName={'Approval In-Principle Expiry Date'}
                            id={'date'} name={(response.StatusDtls.ExpiryDate !==null)? helper.formatDate2(response.StatusDtls.ExpiryDate):'-'} />
                   
                        <div className="row" style={{ width: '100%', marginLeft: '-10px' }}>
                            <hr className="hrgoldline" />
                        </div>
 
                        {showWOProperty && 
                            <AAPNoProperty response={cipAipResponse} propertyData={response.PropertyDetails}/>
                        }

                        {showLeaseholdProp && 
                            <AAPLeaseholdProperty response={cipAipResponse} propertyData={response.PropertyDetails} />
                        }

                        {showFreeholdProp &&
                            <AAPFreeholdProperty response={cipAipResponse} propertyData={response.PropertyDetails}/> 
                        }

                        <div className="row around-xs inputPair elementVisible">
                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                <span><u>{losData.note.title}</u></span><br/><br/> 
                                <span>{losData.note.txt}</span>
                            </div>
                        </div>
                                     
                        <div className="row" style={{ width: '100%', marginLeft: '-10px' }}>
                            <hr className="hrgoldline" />
                        </div>
                        <br />
                    </div>
           
                    <CusSavePrint lb1='Save this PDF' onClick1={exportPDFWithMethod} lb2='Print this' onClick2={printPDF} />

                    <div style={{ textAlign: "center" }} >
                        <CusGreenBtn lbtxt='Back To Home' onClick={handleBacktoHome} />
                        <br />
                        <div className="row around-xs inputPair elementVisible">
                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                <div className='assit-txt'>
                                    <label>{losData.assitance.title}</label>&nbsp;
                                    <label className='add-btn-blue'>{losData.assitance.email}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br />
                    </FormContainer>
                <br />
            </div>
        </PDFExport>
    )
}

export default AIPStatusApproved;